import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Growl } from "primereact/growl";
import servicioHttp from "../servicio/ServicioHttp";
import { Paginator } from 'primereact/paginator';
import servicioFormatos from '../servicio/ServicioFormatos';
import { Button } from 'primereact/button';
import servicioObjetos from '../servicio/ServicioObjetos';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { obtenerInformacionNavegador } from '../servicio/ServicioInformacionNevegador';
import { DEFAULT_MASKS } from '../servicio/ServicioConstantes';
export class TablaImssPatron extends Component {
    constructor() {
        super();
        this.state = {
            desarrollador:false,
            mostrarModalConfirmacion:false,
            errores:{},
            patron:{},
            mostrarModalActualizarPatron:false,
            idsenube: 0,
            paginacion: {
                registrosPorPagina: 10,
                registrosTotales: 0,
                join: null,
                restriccionesDinamicas: [
                ]
            },
        }

    }
    componentDidMount() {
    this.obtenerResultados();
    this.obtnerUsuarioDesarrollador();
    }
    obtnerUsuarioDesarrollador =() =>{
        servicioHttp.consumirPostHttp('usuario/obtener_usuario_sesion_perfil.json').then(response => {
            if(response.data.mensaje==="existe"){
               this.setState({desarrollador:true}); 
            }
         }).catch(error => {
         });
        }
    asignar_restricciones = () => {
        let { paginacion } = this.state;
        paginacion.restriccionesDinamicas = [];
    }
    obtenerResultados = () => {
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp('imss_patron/consultar.json',paginacion).then(response => {
            this.setState({ paginacion: response.data.objeto })
        }).catch(error => {

        });
    }
    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first, paginacion });
        this.obtenerResultados();
    }
    columnaFecha = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fechaVigente)}</div>;
    }
    columnaCuotaFija = (rowData, column) => {
        return <div>{rowData.cuotaFija}%</div>;
    }
    columnaExcedente = (rowData, column) => {
        return <div>{rowData.excedente}%</div>;
    }
    columnaPrestacionesDinero = (rowData, column) => {
        return <div>{rowData.prestacionesDinero}%</div>;
    }

    columnaGastosMedicosPensionados = (rowData, column) => {
        return <div>{rowData.gastosMedicosPensionados}%</div>;
    }
    columnaInvalidezVida = (rowData, column) => {
        return <div>{rowData.invalidezVida}%</div>;
    }
    columnaRetiro = (rowData, column) => {
        return <div>{rowData.retiro}%</div>;
    }
    columnaCesantiaEdadAvanzadaVejez = (rowData, column) => {
        return <div>{rowData.cesantiaEdadAvanzadaVejez}%</div>;
    }
    columnaGuarderiasPrestamosSociales = (rowData, column) => {
        return <div>{rowData.guarderiasPrestamosSociales}%</div>;
    }
    columnaInfonavit = (rowData, column) => {
        return <div>{rowData.infonavit}%</div>;
    }
    cerrarModal = () =>{
        this.setState({mostrarModalActualizarPatron:false});
    }
    mostrarModal = () => {
        this.setState({mostrarModalActualizarPatron:true, patron:{}});
    }
    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }

    guardarPatron =() =>{
        let {patron} =this.state;
        servicioHttp.consumirPostHttp('imss_patron/guardar.json',patron).then(response => {
            this.setState({mostrarModalActualizarPatron:false , patron:{}})
            this.obtenerResultados();
            this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje, life: 6000 }); 
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail:"No se guardo el patron", life: 6000 }); 
        });

    }
    prepararEditar = (rowData) =>{
        let patron = JSON.parse(JSON.stringify(rowData));
       this.setState({patron: patron, mostrarModalActualizarPatron:true});
      }

    plantillaOpciones = (rowData, column) => {
        let{desarrollador} = this.state;
        return <div className="p-grid">
            <div className="p-col-12 p-md-6">
                {desarrollador ?
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.prepararEditar(rowData)}
                    className="p-button-warning" name="editar" tooltip="Editar">
                </Button>
                : null}
            </div>
            <div className="p-col-12 p-md-6">
            {desarrollador ?
                <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(rowData)}
                    className="p-button-danger" name="eliminar" tooltip="Eliminar">
                </Button>
                : null}
            </div>
     </div>;
    }
    mostrarModalEliminar = (rowData) =>{
        let patron = JSON.parse(JSON.stringify(rowData));
        this.setState({ patron: patron, mostrarModalConfirmacion: true });
    }

    eliminar = () => {
        let {patron} = this.state;
        servicioHttp.consumirPostHttp('imss_patron/eliminar.json', patron).then(response => {
            this.setState({ mostrarModalActualizarPatron: false, patron: {}, mostrarModalConfirmacion: false })
            this.obtenerResultados();
            this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje, life: 6000 });
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: "No se elimino la información", life: 6000 });
        });
    }

    render() {
        let {desarrollador,errores,patron,paginacion,idsenube,mostrarModalActualizarPatron} = this.state;
        let propsNavegador = obtenerInformacionNavegador();
       let pieTablaBotones = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-2">
                {desarrollador ?
              <Button className="p-button-secondary" type="button"  name="agregarEjercicio" label="Agregar Ejercicio" tooltip="Agregar Ejercicio" onClick={this.mostrarModal}></Button> 
            : null }
              </div>
        </div>;
         const pieDialogoPatron = (
            <div>
                <Button icon="pi-md-check" label="Aceptar" onClick={this.guardarPatron} />
                <Button icon="pi-md-close" label="Cancelar" onClick={this.cerrarModal} className="p-button-danger flat-btn" />
            </div>
        );
        const dialogFooterConfirmacionEliminar = (
            <div>
                <Button
                    icon="pi-md-check"
                    onClick={this.eliminar}
                    label="Si estoy seguro"
                />
                <Button
                    icon="pi-md-close"
                    onClick={() =>
                        this.setState({
                            tope: {},
                            mostrarModalConfirmacion: false,
                            errores: {},
                        })
                    }
                    label="No estoy seguro"
                    className="p-button-danger flat-btn"
                />
            </div>
        );
        return (
            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <h1>TABLA IMSS PATRÓN</h1>
                        </div>
                    </div>
                </div>
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <DataTable footer={pieTablaBotones} value={paginacion.datos} header="TABLA IMSS PATRÓN" responsive={true} resizableColumns={true} >
                                <Column field="fechaVigente" header="FECHA VIGENTE" style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="riesgoTrabajo" header="RIESGO DE TRABAJO" style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaCuotaFija} header="CUOTA FIJA" style={{ width: '120px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaExcedente} header="EXCEDENTE" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaPrestacionesDinero} header="PRESTACIONES EN DINERO" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaGastosMedicosPensionados} header="GASTOS MEDICOS PENSIONADOS" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaInvalidezVida} header="INVALIDEZ Y VIDA" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaRetiro} header="RETIRO" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaCesantiaEdadAvanzadaVejez} header="CESANTIA EN EDAD AVANZADA Y VEJEZ" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaGuarderiasPrestamosSociales} header="GUARDERIAS Y PRESTAMOS SOCIALES" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaInfonavit}  header="INFONAVIT" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                {desarrollador ?<Column body={this.plantillaOpciones} header="OPCIONES" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} /> : null}
                            </DataTable>
                            <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                        </div>
                    </div>
                    <Dialog style={{ width: propsNavegador.device.type === 'desktop' ? '100%' : '100%', height: '55%' }} appendTo={document.body} header="Actualizar Tabla Imss Patrón" visible={mostrarModalActualizarPatron}
                    modal={true} onHide={this.cerrarModal} footer={pieDialogoPatron}>
                    <div className="p-grid">
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.fechaVigente"><strong>Fecha Vigente:</strong></label>
                        </div>
                      
                        <div className="p-col-12 p-md-2">
                            <InputText keyfilter={DEFAULT_MASKS.money} type="text" id="patron.fechaVigente" name="patron.fechaVigente"
                                value={patron.fechaVigente || ""} className={errores.fechaVigente ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }}  />
                            {errores.fechaVigente ? <Message severity="error" text={errores.fechaVigente} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.riesgoTrabajo"><strong>Riesgo Trabajo:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText type="text" id="patron.riesgoTrabajo" name="patron.riesgoTrabajo"
                                value={patron.riesgoTrabajo || ""} className={errores.riesgoTrabajo ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }}  />
                            {errores.riesgoTrabajo ? <Message severity="error" text={errores.riesgoTrabajo} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.cuotaFija"><strong>Cuota Fija:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText keyfilter={DEFAULT_MASKS.money} type="text" id="patron.cuotaFija" name="patron.cuotaFija"
                                value={patron.cuotaFija || ""} className={errores.cuotaFija ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }}  />
                            {errores.cuotaFija ? <Message severity="error" text={errores.cuotaFija} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.excedente"><strong>Excedente:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText keyfilter={DEFAULT_MASKS.money} type="text" id="patron.excedente" name="patron.excedente"
                                value={patron.excedente || ""} className={errores.excedente ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }}  />
                            {errores.excedente ? <Message severity="error" text={errores.excedente} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.prestacionesDinero"><strong>Prestaciones en dinero:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText keyfilter={DEFAULT_MASKS.money} type="text" id="patron.prestacionesDinero" name="patron.prestacionesDinero"
                                value={patron.prestacionesDinero || ""} className={errores.prestacionesDinero ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }}  />
                            {errores.prestacionesDinero ? <Message severity="error" text={errores.prestacionesDinero} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.gastosMedicosPensionados"><strong>Gastos Medicos Pensionados:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText keyfilter={DEFAULT_MASKS.money} type="text" id="patron.gastosMedicosPensionados" name="patron.gastosMedicosPensionados"
                                value={patron.gastosMedicosPensionados || ""} className={errores.gastosMedicosPensionados ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }}  />
                            {errores.gastosMedicosPensionados ? <Message severity="error" text={errores.gastosMedicosPensionados} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.invalidezVida"><strong>Invalidez y Vida:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText keyfilter={DEFAULT_MASKS.money} type="text" id="patron.invalidezVida" name="patron.invalidezVida"
                                value={patron.invalidezVida || ""} className={errores.invalidezVida ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }}  />
                            {errores.invalidezVida ? <Message severity="error" text={errores.invalidezVida} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.retiro"><strong>Retiro:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText keyfilter={DEFAULT_MASKS.money} type="text" id="patron.retiro" name="patron.retiro"
                                value={patron.retiro || ""} className={errores.retiro ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }}  />
                            {errores.retiro ? <Message severity="error" text={errores.retiro} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.cesantiaEdadAvanzadaVejez"><strong>Cesantia en edad avanzada y vejez:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText keyfilter={DEFAULT_MASKS.money} type="text" id="patron.cesantiaEdadAvanzadaVejez" name="patron.cesantiaEdadAvanzadaVejez"
                                value={patron.cesantiaEdadAvanzadaVejez || ""} className={errores.cesantiaEdadAvanzadaVejez ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }}  />
                            {errores.cesantiaEdadAvanzadaVejez ? <Message severity="error" text={errores.cesantiaEdadAvanzadaVejez} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.guarderiasPrestamosSociales"><strong>Guarderias Presatamos Sociales:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText keyfilter={DEFAULT_MASKS.money} type="text" id="patron.guarderiasPrestamosSociales" name="patron.guarderiasPrestamosSociales"
                                value={patron.guarderiasPrestamosSociales || ""} className={errores.guarderiasPrestamosSociales ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }}  />
                            {errores.guarderiasPrestamosSociales ? <Message severity="error" text={errores.guarderiasPrestamosSociales} /> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="patron.infonavit"><strong>Infonavit:</strong></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <InputText keyfilter={DEFAULT_MASKS.money} type="text" id="patron.infonavit" name="patron.infonavit"
                                value={patron.infonavit || ""} className={errores.infonavit ? "p-error" : ""}
                                onChange={(e) => { this.asignarValores(e, false) }}  />
                            {errores.infonavit ? <Message severity="error" text={errores.infonavit} /> : null}
                        </div>
                    </div>
                </Dialog>
                <Dialog
                            header="Confirmación"
                            visible={this.state.mostrarModalConfirmacion}
                            modal={true}
                            style={{ width: "30vw" }}
                            footer={dialogFooterConfirmacionEliminar}
                            onHide={() =>
                                this.setState({
                                    cliente: {},
                                    mostrarModalConfirmacion: false,
                                    errores: {},
                                })
                            }
                        >
                            <h2>¿Estás seguro de eliminar la información?</h2>
                        </Dialog>
                </div>
            </div>
        );
    }
}